import {
  LABELS_TYPES,
  RA_ADDITIONAL_TYPES,
  RESOURCE_TYPES
} from '../../resource_types';
import { resourceAllocationTypesEnum } from '@linearb/linjs-common';

/* prettier-ignore */
const PALETTES = {
  PROJECTS: ['#4A0077', '#8E04BB', '#D618DA', '#E184D3', '#E4AEB7', '#CC707C', '#F79D36', '#F1B86D', '#EFD75B'],
  ISSUE_TYPES: ['#A2FBFF', '#41BDC4', '#5C8250', '#A2BD4C', '#D5E241', '#FFC3A0', '#FF78AE', '#A145FF', '#D3B8FF'],
  EPICS: ['#CB5588', '#F77748', '#F79D36', '#FAC450', '#5D8F68', '#004D8C', '#0276AB', '#03A9F4', '#7ED7FF'],
  INITIATIVES: ['#497B91', '#59B6CC', '#9FD2FF', '#6883FF', '#4C2CFF', '#4B0092', '#A900B8', '#E25DEE', '#E49EFF'],
  CUSTOM_FIELD: ['#DCF5F9', '#7ACCF7', '#4DB8F3', '#2770A2', '#1C5253', '#4D7C5B', '#8CA947', '#BCCB4B', '#F0DC32'],
  LABELS: ['#265D8A', '#3F98A6', '#C01D87', '#F8865C', '#FAC450', '#001DAE', '#7CBDF8', '#7236D8', '#BF9BFC']
}

export const COLORS_PALLETE_BY_RESOURCE_TYPE = {
  [RESOURCE_TYPES.JIRA_PROJECTS.key]: PALETTES.PROJECTS,
  [RESOURCE_TYPES.JIRA_ISSUE_TYPES.key]: PALETTES.ISSUE_TYPES,
  [RESOURCE_TYPES.JIRA_EPICS.key]: PALETTES.EPICS,
  [RESOURCE_TYPES.JIRA_INITIATIVES.key]: PALETTES.INITIATIVES,
  [LABELS_TYPES.JIRA_LABELS.type]: PALETTES.LABELS,

  [RESOURCE_TYPES.AZURE_WORK_ITEMS.key]: PALETTES.ISSUE_TYPES,
  [RESOURCE_TYPES.AZURE_FEATURES.key]: PALETTES.EPICS,
  [RESOURCE_TYPES.AZURE_EPICS.key]: PALETTES.INITIATIVES,
  [LABELS_TYPES.AZURE_TAGS.type]: PALETTES.LABELS,

  [RA_ADDITIONAL_TYPES.CUSTOM_FIELD]: PALETTES.CUSTOM_FIELD,

  [resourceAllocationTypesEnum.DYNAMIC_ISSUE_TYPE]: PALETTES.EPICS
};
